'use client'

import { Button, Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { IMAGE_BASE_URL } from '../../constants'

const IntroductionSection = () => {
  const translate = useTranslate('item_verification')
  const { track } = useTracking()

  const handleOnCtaClick = () => {
    track(
      clickEvent({
        screen: 'item_verification',
        target: 'cta_redirect',
        targetDetails: `intro_section__${translate('url.cta')}`,
      }),
    )
  }

  return (
    <section className="item-verification__introduction" data-testid="introduction">
      <h1
        className="item-verification__introduction-title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate('introduction.title') }}
      />
      <p className="item-verification__introduction-description">
        {translate('introduction.description')}
      </p>
      <div className="item-verification__introduction-button">
        <Button
          url={translate('url.cta')}
          styling="filled"
          onClick={handleOnCtaClick}
          testId="introduction-cta"
        >
          {translate('actions.primary')}
        </Button>
      </div>
      {/* TODO: `tablets-up` image may be downloaded for phone screens and vice versa. Use `picture` to fix this. */}
      <div>
        <div className="item-verification__introduction-image">
          <Image
            src={`${IMAGE_BASE_URL}/hero-image@2x.png`}
            srcset={`${IMAGE_BASE_URL}/hero-image.png 375w, ${IMAGE_BASE_URL}/hero-image@2x.png 750w, ${IMAGE_BASE_URL}/hero-image@3x.png 1125w, ${IMAGE_BASE_URL}/hero-image-tablets-up.png 1440w, ${IMAGE_BASE_URL}/hero-image-tablets-up@2x.png 2880w, ${IMAGE_BASE_URL}/hero-image-tablets-up@3x.png 4320w`}
            scaling="cover"
          />
        </div>
      </div>
    </section>
  )
}

export default IntroductionSection
